import SelectInput from './SelectInput';
import i18next from 'i18next';
import React, {Component} from 'react';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';
import {selectedSiteId} from '../../store';
import {connect} from 'react-redux';
import * as blockUtils from '../../utils/BlockUtils';
import * as api from '../../api/management-api';

const QUERY_TIME_COOKIE_KEY = 'analytics-chartsQueryTime';
const TERMINAL_COOKIE_KEY = 'analytics-terminalId';
const cookies = new Cookies();

class ChartsQueryTimeSelector extends Component {
  constructor(props) {
    super(props);

    this.updateQueryTime = this.updateQueryTime.bind(this);
    this.updateTerminal = this.updateTerminal.bind(this);
    this.getTerminalsForSite = this.getTerminalsForSite.bind(this);

    this.state = {
      terminals: [],
      selectedTerminal: -1,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.siteId !== prevProps.siteId) {
      this.getTerminalsForSite();
    }
  }

  componentDidMount() {
    this.setState({
      selectedTerminal: cookies.get(TERMINAL_COOKIE_KEY) || '-1',
    });
    this.getTerminalsForSite();
  }

  getTerminalsForSite() {
    const siteId = this.props.siteId;

    if (!siteId || siteId === -1 || this.props.showTerminals === false) {
      return;
    }

    this.setState({
      terminals: [],
    });

    blockUtils.blockUI();
    api.getSimpleTerminals(siteId).then((chartsResponse) => {
      const terminals = chartsResponse.data;
      const selectedTerminal = this.state.selectedTerminal;

      if (selectedTerminal) {
        const existingTerminal = terminals.filter((terminal) => {
          return terminal.terminalId === selectedTerminal;
        });

        if (existingTerminal.length === 0) {
          const e = {
            target: {
              value: terminals[0].terminalId,
            },
          };
          this.updateTerminal(e);
        }
      }

      this.setState({
        terminals: terminals,
      });
    }).catch((error) => {
      const errorMessage = error.response.data.errorMessage;
      window.showAlert(i18next.t('error'), errorMessage);
    });
  }

  getValuesForTimeInterval() {
    return [
      {'id': 'one_day_hourly', 'name': i18next.t('terminals.times.one_day_hourly')},
      {'id': 'two_days_hourly', 'name': i18next.t('terminals.times.two_days_hourly')},
      {'id': 'one_week_hourly', 'name': i18next.t('terminals.times.one_week_hourly')},
      {'id': 'two_weeks_hourly', 'name': i18next.t('terminals.times.two_weeks_hourly')},
      {'id': 'one_month_daily', 'name': i18next.t('terminals.times.one_month_daily')},
      {'id': 'three_month_daily', 'name': i18next.t('terminals.times.three_month_daily')},
      {'id': 'one_year_weekly', 'name': i18next.t('terminals.times.one_year_weekly')},
    ];
  }

  updateQueryTime(e) {
    cookies.set(QUERY_TIME_COOKIE_KEY, e.target.value, {expires: new Date(Date.now() + 31536000000)});
    this.props.onTimeChange();
  }

  updateTerminal(e) {
    cookies.set(TERMINAL_COOKIE_KEY, e.target.value, {expires: new Date(Date.now() + 31536000000)});
    this.setState({
      selectedTerminal: e.target.value,
    });
    this.props.onTimeChange();
  }

  render() {
    const chosenTimeFromCookie = cookies.get(QUERY_TIME_COOKIE_KEY);
    if (!chosenTimeFromCookie) {
      cookies.set(QUERY_TIME_COOKIE_KEY, 'two_days_hourly', {expires: new Date(Date.now() + 31536000000)});
    }
    const chosenTime = cookies.get(QUERY_TIME_COOKIE_KEY);

    const options = [];
    if (this.state.terminals && this.state.terminals.length > 0) {
      this.state.terminals.forEach((terminal) => options.push({id: terminal.terminalId, name: terminal.name}));
    }

    return (
      <div className="row col-md-12">
        <div className="col-md-6">
          <SelectInput
            fieldId="chartsQueryTime"
            labelText={i18next.t('terminals.options.chartsQueryTime')}
            selected={chosenTime}
            onChange={this.updateQueryTime}
            values={this.getValuesForTimeInterval()}
            isRequired={true}
          />
        </div>
        {this.props.showTerminals && this.state.terminals && this.state.terminals.length > 0 ?
          <div className="col-md-6">
            <SelectInput
              fieldId="terminals"
              labelText={i18next.t('terminals.options.terminal')}
              selected={this.state.selectedTerminal}
              onChange={this.updateTerminal}
              values={options}
              isRequired={true}
            />
          </div> :
          null
        }
      </div>
    );
  }
}

ChartsQueryTimeSelector.propTypes = {
  onTimeChange: PropTypes.func,
  siteId: PropTypes.number,
  showTerminals: PropTypes.bool,
};

const mapStateToProps = function(store) {
  const currentSiteId = store.sitesState.currentSiteId === -1 ? selectedSiteId() : store.sitesState.currentSiteId;
  return {
    siteId: currentSiteId,
  };
};

export default connect(mapStateToProps)(ChartsQueryTimeSelector);
